<template>
    <Poptip v-if="git" trigger="hover" title="Git" placement="top">
        <Icon type="ios-git-branch" :style="{fontSize: '22px'}"></Icon>
        <div slot="content">
            <ul>
                <li>Nome: {{git.nome}}</li>
                <li>Repositório: {{git.repo}}</li>
                <li v-if="git.pr_url">
                    PR: <a :href="git.pr_url" target="_blank">{{git.pr_url}}</a>
                </li>
            </ul>
        </div>
    </Poptip>
</template>

<script>
    export default {
        name: "pgd-git",
        props: ["git"]
    };
</script>
